<template src="./brancheslist.html"></template>
<script>
import Axios from "axios";
import $ from "jquery";
import { required, sameAs } from "vuelidate/lib/validators";
import Endpoints from "@/config/ApiEndpoints.js";

export default {
  components: {},
  filters: {
    date: function (data) {
      if (data == "" || data == null) {
        return "N/A";
      }
      var reqdString = "";
      for (let i = 0; i < 10; i++) {
        reqdString += data[i];
      }
      var arr = reqdString.split("-");
      reqdString = arr[2] + "-" + arr[1] + "-" + arr[0];
      return reqdString;
    },
  },
  data() {
    return {
      Branches: [],
      submitted: false,
      Saving: false,
      basic: {
        currentPage: 1,
        totalPages: 0,
      },
      filter: {
        currentPage: 1,
        totalPages: 0,
      },
      filters: {
        name: {
          value: "",
          keys: [
            "name",
            "address",
            "city",
            "town",
            "county",
            "postcode",
            "email",
            "contact_number",
          ],
        },
      },
      ShowBranchAdd: false,
      ShowBranchEdit: false,
      ShowBranchDelete: false,
    };
  },
  mounted() {
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    var FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(FleetSubscription.fleet_modules);
    if (
      FleetSubscriptionModules["Hierarchy System"] &&
      (!AccountPermissions.Branches || !AccountPermissions.Branches.enable)
    ) {
      this.$router.push("/");
    }
    if (
      AccountPermissions &&
      AccountPermissions.Branches &&
      AccountPermissions.Branches.enable
    ) {
      if (AccountPermissions.Branches.add) {
        this.ShowBranchAdd = true;
      }
      if (AccountPermissions.Branches.edit) {
        this.ShowBranchEdit = true;
      }
      if (AccountPermissions.Branches.delete) {
        this.ShowBranchDelete = true;
      }
    }
    if (!FleetSubscriptionModules["Hierarchy System"]) {
      this.ShowBranchAdd = true;
      this.ShowBranchEdit = true;
      this.ShowBranchDelete = true;
    }
    document.title = pbx_SiteTitle + " - Company Branches";
    this.GetBranches();
  },

  methods: {
    GetBranches() {
      this.SearchLoader = true;
      var obj = { token: localStorage.getItem("token") };
      this.ShowLoader = true;
      Axios.post(Endpoints.Branch.List, obj).then((Response) => {
        this.ShowLoader = false;
        if (Response.data.success) {
          this.SearchLoader = false;
          this.Branches = Response.data.records;
        }
      });
    },
    DeleteBranch(branch_id) {
      this.$swal({
        title: "Are you sure You want to delete?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal.fire({
            title: "Deleting...",
            text: "Please wait...",
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.Branch.Delete, {
            token: localStorage.getItem("token"),
            branch_id: branch_id,
          }).then((Response) => {
            if (Response.data.success === true) {
              this.$swal.close();
              this.GetBranches();
              this.$swal
                .fire("Branch Deleted Successfully", "", "success")
                .then(() => {});
            } else {
              this.$swal
                .fire("Error:" + Response.data.message, "", "error")
                .then(() => {});
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.branchesBody td {
  padding-left: 15px !important;
}
.branchesBody .btn-primary {
  border: 1px solid transparent !important;
}
.table thead th,
.table th,
.table td {
  border: 0 !important;
}
@media (min-width: 1280px) and (max-width: 1680px) {
  .actionBTN {
    width: 25%;
  }
}
@media (min-width: 780px) and (max-width: 1370px) {
  .actionBTN {
    min-width: 190px;
  }
}
</style>
